import { string } from "prop-types";
import { databaseSystemDefinedPropertiesType } from "./databaseSystemDefinedPropertiesType";

/** @deprecated use TypeScript interface or type instead */
export const baseDatabaseModelType = {
  ...databaseSystemDefinedPropertiesType,
  createdAt: string,
  createdBy: string,
  updatedAt: string,
  updatedBy: string,
};
